import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import "./candidate-Dashboard.css";
import { sendEditCandidateRequest } from "../../../services/candidate/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import "./candidate-Dashboard.css";
import { getCandidateDashboard } from "../../../services/candidate/api";
import { getS3key } from "../../../services/employee/api";


const CandidateDashboard = () => {
  const navigate = useNavigate();
  const { candidateId } = useParams();
  const [progress, setProgress] = useState(70);
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [profileImage, setProfileImage] = useState(null);

  const handleCheckboxChange = (value) => {
    setSelectedRequests((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const requestOptions = [
    { label: "Personal Details", value: "PERSONAL_DETAILS" },
    { label: "Address Details", value: "ADDRESS_DETAILS" },
    { label: "Education Details", value: "EDUCATION_DETAILS" },
    { label: "Employment Details", value: "EMPLOYMENT_DETAILS" },
  ];
  const handleSendRequest = async () => {
    try {
      if (selectedRequests.length === 0) {
        toast.error("Please select at least one request");
        return;
      }

      const result = await sendEditCandidateRequest(selectedRequests);

      toast.success(result.message || "Request sent successfully!");
    } catch (err) {
      toast.error(err.message || "Failed to send request");
    }
  };

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const data = await getCandidateDashboard();
        const created = new Date(data.createdDate);
        const expiryDate = new Date(created.getTime() + 5 * 24 * 60 * 60 * 1000);
        setDashboardData({ ...data, expiryDate });
        updateTimeLeft(expiryDate);

        if (data.personalImageFileName) {
          loadProfileImage(data.personalImageFileName);
        }
      } catch (err) {
      }
    };
    fetchDashboard();
  }, []);

  const loadProfileImage = async (fileKey) => {
    try {
      if (!fileKey) return;

      let key = fileKey;

      if (key.includes(".com/")) {
        key = key.split(".com/")[1];
      }

      key = decodeURIComponent(key);

      const response = await getS3key(key);

      const blobUrl = URL.createObjectURL(response.data);

      setProfileImage(blobUrl);

    } catch (error) {
      console.error("Error loading profile image:", error);
    }
  };

  useEffect(() => {
    return () => {
      if (profileImage?.startsWith("blob:")) {
        URL.revokeObjectURL(profileImage);
      }
    };
  }, [profileImage]);

  const updateTimeLeft = (expiryDate) => {
    const now = new Date();
    const diff = expiryDate - now;
    if (diff <= 0) {
      setTimeLeft({ expired: true });
      return;
    }
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    setTimeLeft({ days, hours, minutes, seconds, expired: false });
  };


  useEffect(() => {
    if (!dashboardData?.expiryDate) return;
    const interval = setInterval(() => {
      updateTimeLeft(dashboardData.expiryDate);
    }, 1000);
    return () => clearInterval(interval);
  }, [dashboardData]);
  if (!dashboardData || !timeLeft) return <div className="centered-message">
    <div className="spinner"></div>
    <div>Loading details...</div>
  </div>;
  if (timeLeft.expired) {
    return (
      <div className="candidate-dash-container">
        <h2 className="expired-message">⚠️ Login Expired</h2>
        <p>Your login credentials have expired.</p>
      </div>
    );
  }


  return (
    <div className="candidate-dash-container">
      <h3 className="candidate-dash-header">Overview</h3>

      <div className="candidate-dash-row">
        <div className="candidate-dash-card">
          <div className="candidate-dash-profile">
            <img
              src={
                profileImage ||
                "https://media.istockphoto.com/id/1327592506/vector/default-avatar-photo-placeholder-icon-grey-profile-picture-business-man.jpg?s=612x612&w=0&k=20&c=BpR0FVaEa5F24GIw7K8nMWiiGmbb8qmhfkpXcp1dhQg="
              }
              alt="candidate-profile"
              className="candidate-dash-avatar"
            />
            <p className="candidate-dash-name">
              {dashboardData.firstName} {dashboardData.lastName}
            </p>

          </div>
        </div>

        <div className="candidate-dash-card">
          <h3 className="candidate-dash-title">Verification Status</h3>
          <div className="candidate-dash-progress">
            <svg viewBox="0 0 36 36" className="candidate-dash-circular">
              <path
                className="candidate-dash-bg"
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                className="candidate-dash-progress-path"
                strokeDasharray={`${dashboardData.verificationPercentage}, 100`}
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" className="candidate-dash-percentage">
                {dashboardData.verificationPercentage}%
              </text>
            </svg>
          </div>
        </div>

        <div className="candidate-dash-card">
          <h3 className="candidate-dash-title">Login Credentials Expire In</h3>
          <div className="candidate-dash-timer">
            <div className="candidate-dash-timebox">
              {timeLeft.days} <span>Days</span>
            </div>
            <div className="candidate-dash-timebox">
              {timeLeft.hours} <span>Hours</span>
            </div>
            <div className="candidate-dash-timebox">
              {timeLeft.minutes} <span>Min</span>
            </div>
            <div className="candidate-dash-timebox">
              {timeLeft.seconds} <span>Sec</span>
            </div>
          </div>
        </div>
      </div>

      <div className="candidate-dash-row">
        <div className="candidate-dash-card">
          <h3 className="candidate-dash-title">Submitted Data</h3>
          <div className="candidate-dash-view" style={{ cursor: "pointer" }} onClick={() =>


            navigate(`/candidate-details/${candidateId}`, {
              state: {
                heading: 'Candidate Report',
                candidate: candidateId,
              },
            })
          }
          >
            <FaEye className="candidate-dash-eye" />
            <p>Click here to view</p>
          </div>


        </div>

        <div className="candidate-dash-card">
          <h3 className="candidate-dash-title">Requested to Edit Data</h3>
          <ul className="candidate-dash-editlist">
            {requestOptions.map((item) => (
              <li key={item.value}>
                <input
                  type="checkbox"
                  value={item.value}
                  checked={selectedRequests.includes(item.value)}
                  onChange={(e) => handleCheckboxChange(e.target.value)}
                />
                <label> {item.label}</label>
              </li>
            ))}
          </ul>
          <div className="send-request-btn">
            <button type="button" onClick={handleSendRequest}>
              Send Request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDashboard;
